import React from 'react'
import DefaultInfoBar from './DefaultInfoBar';
import CustomInfoBar from './CustomInfoBar';
import './EasySoftwareInfoBar.scss'
import { PuxWysiwygHtmlBodyType } from '../PuxWysiwyg/PuxWysiwyg';

interface EasySoftwareInfoBarProps {
  text: PuxWysiwygHtmlBodyType | null,
  resetDate: string | null,
  path?: string
}

const EasySoftwareInfoBar = (props: EasySoftwareInfoBarProps) => {
  const isCustomBar = props.text?.html && props.text.html.length > 0;

  return isCustomBar ? (
    <CustomInfoBar {...props} text={props.text!} />
  ) : (
    <DefaultInfoBar />
  )
}

export default EasySoftwareInfoBar;
